<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">商品列表</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>新增商品</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回商品列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item
            label="商品名称"
            prop='good_name'
          >
            <el-input
              v-model="form.good_name"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="是否是套餐商品"
            prop="good_type"
          >
            <el-select 
              v-model="form.good_type"
              placeholder="全部"
            >
              <el-option
                label="是套餐商品"
                value='1'
              ></el-option>
              <el-option
                label="不是"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item v-if="form.good_type == 1"
            label="关联普通商品"
            prop='subId'
          >
            <el-input
              v-model="form.subId"
              placeholder="请输入普通商品id"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item v-if="form.good_type == 1"
            label="关联普通商品数量"
            prop='subIdNum'
          >
            <el-input
              v-model="form.subIdNum"
              placeholder="请输入普通商品数量"
              type="number"
            ></el-input>
          </el-form-item> -->


          <el-form-item v-if="form.good_type == 1" v-for="(domain, index) in form.domains" :label="'商品' + index" :key="domain.goodId"
            :prop="'domains.' + index + '.goodId'" :rules="{
                        required: true, message: '商品不能为空', trigger: 'blur'
                      }">
            <div style="display:flex">
              <el-input v-model="domain.goodId" type="number"></el-input>
              <span style="display: inline-block; width: 100px;margin-left: 10px;">数量:</span>
              <el-input v-model="domain.num" type="number"></el-input>
            </div>
            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
          </el-form-item>
          <el-form-item v-if="form.good_type == 1">
            <el-button @click="addDomain">新增关联普通商品</el-button>
          </el-form-item>

          <el-form-item
            label="防串货ID"
            prop='thirdId'
          >
            <el-input
              v-model="form.thirdId"
              placeholder="请输入防串货ID"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="是否是耗材"
            prop="no_vip"
          >
            <el-select
              @change="changeGoodType"
              v-model="form.no_vip"
              placeholder="全部"
            >
              <el-option
                label="不是"
                value='1'
              ></el-option>
              <el-option
                label="是"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-show="form.no_vip == 2"
            label="只允许董事购买"
            prop="topBuyStatus"
          >
            <el-select 
              v-model="form.topBuyStatus"
              placeholder="全部"
            >
              <el-option
                label="不是"
                value='2'
              ></el-option>
              <el-option
                label="是"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="form.no_vip == 2"
            label="是否已售罄"
            prop="topFullStatus"
          >
            <el-select 
              v-model="form.topFullStatus"
              placeholder="全部"
            >
              <el-option
                label="不是"
                value='2'
              ></el-option>
              <el-option
                label="是"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="是否是束宣"
            prop="suType"
          >
            <el-select
              v-model="form.suType"
              placeholder="全部"
            >
              <el-option
                label="不是"
                value='2'
              ></el-option>
              <el-option
                label="是"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="是否可以调货-买入"
            prop="noAdjustableGoods"
          >
            <el-select
              v-model="form.noAdjustableGoods"
              placeholder="全部"
            >
              <el-option
                label="不可调"
                value='2'
              ></el-option>
              <el-option
                label="可调"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否可以调货-调出"
            prop="can_out_type"
          >
            <el-select
              v-model="form.can_out_type"
              placeholder="全部"
            >
              <el-option
                label="不可调"
                value='2'
              ></el-option>
              <el-option
                label="可调"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="商品类型"
            prop="type_id"
          >
            <el-select v-model="form.type_id">
              <el-option
                v-for="option in typeOptions1"
                :value="option.id"
                :key='option.id'
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item
            label="商品库存"
            prop='good_num'
          >
            <el-input
              type="number"
              v-model="form.good_num"
              placeholder="请输入库存，只能是大于0的整数"
            ></el-input>
          </el-form-item> -->
          <!--
          <el-form-item
            v-show="form.first_type_id != 4"
            label="定时上架时间"
            prop='begin_time'
          >
            <el-date-picker
              v-model="form.begin_time"
              align="center"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-show="form.first_type_id != 4"
            label="售卖开始时间"
            prop='sold_time'
          >
            <el-date-picker
              v-model="form.sold_time"
              align="center"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-show="form.first_type_id != 4"
            label="定时下架时间"
            prop='end_time'
          >
            <el-date-picker
              v-model="form.end_time"
              align="center"
              type="datetime"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item> -->

          <!-- <el-form-item
            label="件数"
            prop='num'
          >
            <el-input
              v-model="form.num"
              placeholder="2"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item
            label="商品分类"
            prop="choose_type"
          >
            <el-cascader
              expand-trigger="hover"
              :options="options"
              :props='props'
              v-model="form.choose_type"
            >
            </el-cascader>
          </el-form-item> -->
          <el-form-item
            v-show="form.no_vip != 2"
            label="首页推荐"
            prop="status"
          >
            <el-select
              v-model="form.index_status"
              placeholder="是"
            >
              <el-option
                label="是"
                value='1'
              ></el-option>
              <el-option
                label="否"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="上架状态"
            prop="status"
          >
            <el-select
              v-model="form.status"
              placeholder="全部"
            >
              <el-option
                label="待上架"
                value='1'
              ></el-option>
              <el-option
                label="上架"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="康减系列购买"
            prop="special_type"
          >
            <el-select
              v-model="form.special_type"
              placeholder="全部"
            >
              <el-option
                label="不可以购买"
                value='1'
              ></el-option>
              <el-option
                label="可以购买"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="￥原价格"
            prop='good_price'
          >
            <el-input
              v-model="form.good_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="体积"
            prop='goodSize'
          >
            <el-input
              v-model="form.goodSize"
              placeholder="体积只能是数字，不能有字符串"
            >
              <template slot="append">m³</template>
            </el-input>
          </el-form-item>

          <el-form-item
            label="重量"
            prop='goodWeight'
          >
            <el-input
              v-model="form.goodWeight"
              placeholder="重量只能是数字，不能有字符串"
            >
              <template slot="append">kg</template>
            </el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip == 2"
            label="￥积分价格"
            prop='score_price'
          >
            <el-input
              v-model="form.score_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥赠送积分"
            prop='send_score'
          >
            <el-input
              v-model="form.send_score"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥康减系列vip会员价格"
            prop='unit_price'
          >
            <el-input
              v-model="form.unit_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥康减系列高级会员价格"
            prop='unit_second_price'
          >
            <el-input
              v-model="form.unit_second_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥康减系列荣誉会员价格"
            prop='unit_three_price'
          >
            <el-input
              v-model="form.unit_three_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥康减系列市代价格"
            prop='unit_city_price'
          >
            <el-input
              v-model="form.unit_city_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥康减系列省代价格"
            prop='unit_province_price'
          >
            <el-input
              v-model="form.unit_province_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥康减系列ceo价格"
            prop='unit_ceo_price'
          >
            <el-input
              v-model="form.unit_ceo_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥VIP门店价格"
            prop='vip_price'
          >
            <el-input
              v-model="form.vip_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥联盟店价格"
            prop='district_price'
          >
            <el-input
              v-model="form.district_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥优秀联盟店价格"
            prop='nice_district_price'
          >
            <el-input
              v-model="form.nice_district_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥市代价格"
            prop='city_price'
          >
            <el-input
              v-model="form.city_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥特殊市代价格"
            prop='special_city_price'
          >
            <el-input
              v-model="form.special_city_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥省代价格"
            prop='province_price'
          >
            <el-input
              v-model="form.province_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥特殊省代价格"
            prop='special_province_price'
          >
            <el-input
              v-model="form.special_province_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥CEO价格"
            prop='ceo_price'
          >
            <el-input
              v-model="form.ceo_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥总经销商价格"
            prop='top_price'
          >
            <el-input
              v-model="form.top_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-show="form.no_vip != 2"
            label="￥特殊价格"
            prop='special_price'
          >
            <el-input
              v-model="form.special_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>



          <el-form-item
            v-show="form.no_vip != 2"
            label="￥董事二级推价格"
            prop='new_ceo_two_money'
          >
            <el-input
              v-model="form.new_ceo_two_money"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥董事一级推价格"
            prop='new_ceo_one_money'
          >
            <el-input
              v-model="form.new_ceo_one_money"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥合伙人推合伙人价格"
            prop='new_pro_pro_money'
          >
            <el-input
              v-model="form.new_pro_pro_money"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥区域总监价格"
            prop='new_area_money'
          >
            <el-input
              v-model="form.new_area_money"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥城市加盟商价格"
            prop='exec_price'
          >
            <el-input
              v-model="form.exec_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥经销商价格"
            prop='xing_role_price'
          >
            <el-input
              v-model="form.xing_role_price"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥合伙人价格"
            prop='new_province_money'
          >
            <el-input
              v-model="form.new_province_money"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="form.no_vip != 2"
            label="￥董事价格"
            prop='new_ceo_money'
          >
            <el-input
              v-model="form.new_ceo_money"
              placeholder="价格只能是数字，不能有字符串"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="权重"
            prop='order_index'
          >
            <el-input
              v-model="form.order_index"
              placeholder="请输入权重，数字越大排序越靠前"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="康减系列vip补货数量"
            prop='vip_red_num'
          >
            <el-input
              v-model="form.vip_red_num"
              placeholder="请输入康减系列vip补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="康减系列高级补货数量"
            prop='high_red_num'
          >
            <el-input
              v-model="form.high_red_num"
              placeholder="请输入康减系列高级补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="康减系列荣誉补货数量"
            prop='top_red_num'
          >
            <el-input
              v-model="form.top_red_num"
              placeholder="请输入康减系列荣誉补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="康减系列市代补货数量"
            prop='red_city_num'
          >
            <el-input
              v-model="form.red_city_num"
              placeholder="请输入康减系列市代补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="康减系列省代补货数量"
            prop='red_province_num'
          >
            <el-input
              v-model="form.red_province_num"
              placeholder="请输入康减系列省代补货数量"
              type="number"
            ></el-input>
          </el-form-item>

<el-form-item
            label="康减系列CEO补货数量"
            prop='red_ceo_num'
          >
            <el-input
              v-model="form.red_ceo_num"
              placeholder="请输入康减系列CEO补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="vip门店补货数量"
            prop='vip_buy_num'
          >
            <el-input
              v-model="form.vip_buy_num"
              placeholder="请输入vip门店补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="联盟店补货数量"
            prop='high_buy_num'
          >
            <el-input
              v-model="form.high_buy_num"
              placeholder="请输入联盟店补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="优秀高级补货数量"
            prop='nice_high_num'
          >
            <el-input
              v-model="form.nice_high_num"
              placeholder="请输入优秀高级补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="市代补货数量"
            prop='city_buy_num'
          >
            <el-input
              v-model="form.city_buy_num"
              placeholder="请输入市代补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="战略省代补货数量"
            prop='province_buy_num'
          >
            <el-input
              v-model="form.province_buy_num"
              placeholder="请输入战略省代补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="门店省代补货数量"
            prop='shop_province_buy_num'
          >
            <el-input
              v-model="form.shop_province_buy_num"
              placeholder="请输入门店省代补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="ceo补货数量"
            prop='ceo_buy_num'
          >
            <el-input
              v-model="form.ceo_buy_num"
              placeholder="请输入ceo补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="董事补货数量"
            prop='new_ceo_buy_num'
          >
            <el-input
              v-model="form.new_ceo_buy_num"
              placeholder="请输入董事补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="新province补货数量"
            prop='new_province_buy_num'
          >
            <el-input
              v-model="form.new_province_buy_num"
              placeholder="请输入新province补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="区域总监补货数量"
            prop='new_area_buy_num'
          >
            <el-input
              v-model="form.new_area_buy_num"
              placeholder="请输入区域总监补货数量"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="城市加盟商补货数量"
            prop='exec_buy_num'
          >
            <el-input
              v-model="form.exec_buy_num"
              placeholder="请输入城市加盟商补货数量"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="经销商数量"
            prop='xing_role_num'
          >
            <el-input
              v-model="form.xing_role_num"
              placeholder="请输入城市加盟商补货数量"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="列表图片"
            prop="list_pic"
          >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data='tokenData'
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form.list_pic"
                :src="form.list_pic"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="赠送图片"
            prop="give_pic"
          >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data='tokenData'
              :on-success="handleAvatarSuccessGive"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form.give_pic"
                :src="form.give_pic"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="介绍视频"
            prop='video_path'
          >
            <el-input
              v-model="form.video_path"
              placeholder="请输入介绍视频地址"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="轮播图片"
            prop="main_pic"
          >
            <el-upload
              class="upload-demo"
              :multiple='true'
              action="/manager/user/seven_app_file_up"
              :on-preview="handlePreview"
              :on-success="handleAvatarSuccess1"
              :on-remove="handleRemove"
              :data='tokenData'
              :file-list="fileList2"
              list-type="picture"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：375px × 375px</div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="文本描述"
            prop='content'
          >
            <el-input
              v-model="form.content"
              type="textarea"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="详情图片"
          >
            <el-upload
              class="upload-demo"
              :multiple='true'
              action="/manager/user/seven_app_file_up"
              :on-preview="handlePreview"
              :on-success="handleAvatarSuccess2"
              :on-remove="handleRemove1"
              :data='tokenData'
              :file-list="fileList3"
              list-type="picture"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：宽375px 高无限</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button @click="backList">返回列表</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
var _ = require("lodash");
export default {
  name: "add_good",
  data() {
    return {
      typeOptions: [],
      typeOptions1:[],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      options: [],
      good: null,
      wordName: "新增",
      props: {
        value: "id",
        label: "type_name"
      },
      addFormRule: {
        vip_red_num: [
          {
            required: true,
            message: "请输入康减系列VIP补货数量",
            trigger: "blur"
          }
        ],
        high_red_num: [
          {
            required: true,
            message: "请输入康减系列高级补货数量",
            trigger: "blur"
          }
        ],
        top_red_num: [
          {
            required: true,
            message: "请输入康减系列荣誉补货数量",
            trigger: "blur"
          }
        ],
        red_city_num: [
          {
            required: true,
            message: "请输入康减系列市代补货数量",
            trigger: "blur"
          }
        ],
        red_province_num: [
          {
            required: true,
            message: "请输入康减系列省代补货数量",
            trigger: "blur"
          }
        ],
        red_ceo_num: [
          {
            required: true,
            message: "请输入康减系列CEO补货数量",
            trigger: "blur"
          }
        ],
        vip_buy_num: [
          {
            required: true,
            message: "请输入VIP门店补货数量",
            trigger: "blur"
          }
        ],
        high_buy_num: [
          {
            required: true,
            message: "请输入联盟店补货数量",
            trigger: "blur"
          }
        ],
        nice_high_num: [
          {
            required: true,
            message: "请输入优秀高级补货数量",
            trigger: "blur"
          }
        ],
        city_buy_num: [
          {
            required: true,
            message: "请输入市代补货数量",
            trigger: "blur"
          }
        ],
        province_buy_num: [
          {
            required: true,
            message: "请输入战略省代补货数量",
            trigger: "blur"
          }
        ],
        shop_province_buy_num: [
          {
            required: true,
            message: "请输入门店省代补货数量",
            trigger: "blur"
          }
        ],
        ceo_buy_num: [
          {
            required: true,
            message: "请输入ceo补货数量",
            trigger: "blur"
          }
        ],
        new_ceo_buy_num: [
          {
            required: true,
            message: "请输入董事补货数量",
            trigger: "blur"
          }
        ],
        new_province_buy_num: [
          {
            required: true,
            message: "请输入合伙人补货数量",
            trigger: "blur"
          }
        ],
        xing_role_num: [
          {
            required: true,
            message: "请输入经销商补货数量",
            trigger: "blur"
          }
        ],
        exec_buy_num: [
          {
            required: true,
            message: "请输入城市加盟商补货数量",
            trigger: "blur"
          }
        ],
        new_area_buy_num: [
          {
            required: true,
            message: "请输入区域总监补货数量",
            trigger: "blur"
          }
        ],
        thirdId: [
          {
            required: true,
            message: "请输入防串货ID",
            trigger: "blur"
          }
        ],
        good_name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          }
        ],
        normal_price: [
          {
            required: true,
            message: "请输入原价价格",
            trigger: "blur"
          }
        ],

        goodWeight: [
          {
            required: true,
            message: "请输入重量",
            trigger: "blur"
          }
        ],
        goodSize: [
          {
            required: true,
            message: "请输入体积",
            trigger: "blur"
          }
        ],

        give_pic: [
          {
            required: true,
            message: "请上传赠送图片",
            trigger: "blur"
          }
        ],
        list_pic: [
          {
            required: true,
            message: "请上传列表图片",
            trigger: "blur"
          }
        ],
        main_pic: [
          {
            required: true,
            message: "请上传轮播图片",
            trigger: "blur"
          }
        ],
        type_id: [
          {
            required: true,
            message: "请选择商品分类",
            trigger: "blur"
          }
        ],
        status: [
          {
            required: true,
            message: "请选择上架状态",
            trigger: "blur"
          }
        ],
        special_type: [
          {
            required: true,
            message: "请选择康减系列是否可以购买",
            trigger: "blur"
          }
        ],
        score_price: [
          {
            required: true,
            message: "请输入原价",
            trigger: "blur"
          }
        ],
        no_vip: [
          {
            required: true,
            message: "请选择是否是耗材",
            trigger: "blur"
          }
        ],
        good_type: [
          {
            required: true,
            message: "请选择是否是套餐商品",
            trigger: "blur"
          }
        ],
        topBuyStatus: [
          {
            required: true,
            message: "请选择是否只有董事可以买",
            trigger: "blur"
          }
        ],topFullStatus: [
          {
            required: true,
            message: "请选择是否已售罄",
            trigger: "blur"
          }
        ],
        suType: [
          {
            required: true,
            message: "请选择是否是束宣",
            trigger: "blur"
          }
        ],
        noAdjustableGoods: [
          {
            required: true,
            message: "请选择是否可调",
            trigger: "blur"
          }
        ],
        can_out_type: [
          {
            required: true,
            message: "请选择是否可调",
            trigger: "blur"
          }
        ],
        // good_num: [
        //   {
        //     required: true,
        //     message: "请输入库存",
        //     trigger: "blur"
        //   }
        // ],
        index_status: [
          {
            required: true,
            message: "请选择上是否推荐",
            trigger: "blur"
          }
        ],
        detail_pic: [
          {
            required: true,
            message: "请上传详情图片",
            trigger: "blur"
          }
        ]
      },
      addLoading: false,
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      form: {
        domains: [],
        thirdId:null,
        subId:null,
        subIdNum:null,
        score_price:0,
        send_score:0,
        top_price:null,
        ceo_buy_num:0,
        new_ceo_buy_num:0,
        new_province_buy_num:0,
        shop_province_buy_num:0,
        new_area_buy_num:0,
        province_buy_num:0,
        exec_buy_num:0,
        xing_role_num:0,
        city_buy_num:0,
        vip_red_num:0,
        high_red_num:0,
        top_red_num:0,
        red_city_num:0,
        red_province_num:0,
        red_ceo_num:0,
        video_path:null,
        vip_buy_num:0,
        high_buy_num:0,
        nice_high_num:0,
        // limit_num: 0,
        // sold_time: null,
        // limit_status: "2",
        // begin_time: null,
        // com_info: null,
        order_index:null,
        unit_three_price:null,
        unit_second_price:null,
        good_price: 0,
        goodSize: 0,
        goodWeight: 0,
        index_status:'2',
        nice_district_price:null,
        district_price: null,
        vip_price:null,
        no_vip:'1',
        suType:'2',
        topBuyStatus:'2',
        good_type:'2',
        topFullStatus:'2',
        noAdjustableGoods: "2",
        can_out_type:'2',
        special_city_price:null,
        special_province_price:null,
        city_price: null,
        province_price: null,
        ceo_price: null,
        special_price: null,

        new_ceo_two_money: null,
        new_ceo_one_money: null,
        new_pro_pro_money: null,
        exec_price:null,
        xing_role_price:null,
        new_area_money: null,
        new_province_money: null,
        new_ceo_money: null,

        good_num: null,
        type_id: null,
        id: null,
        good_name: null,
        list_pic: null,
        main_pic: null,
        normal_price: null,
        content: null,
        status: null,
        special_type:null,
        unit_price:null,
        give_pic:null,
        unit_city_price:null,
        unit_province_price:null,
        unit_ceo_price:null,
        fileList3: [],
        fileList2: []
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    this.page_num = 1;
    let params = {
      pageNum: 1,
      pageSize: 100,
      infoType: 1,
      token: localStorage.getItem("api_token")
    };
    that.loading = true;
    API.good_first_type_list(params)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            that.typeOptions = [];
            for (var i = 0; i < result.result.list.length; i++) {
              if (result.result.list[i].title != "全部") {
                that.typeOptions.push(result.result.list[i]);
                // typeOptions1
                if (result.result.list[i].noVip == parseInt(that.form.no_vip))
                {
                  that.typeOptions1.push(result.result.list[i]);
                }
              }
            }
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    var good = this.$route.query.good;
    this.good = good;
    var para = {
      id: this.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      console.info(good);
      that.wordName = "修改";
      that.form.id = good.id;
      if(this.$route.query.copyType && this.$route.query.copyType == 1){
        that.wordName = "立即创建";
        that.form.id = null;
      }
      that.form.no_vip = good.no_vip.toString();
      that.form.suType = good.su_type.toString();
      that.form.topBuyStatus = good.top_buy_status.toString();
      that.form.good_type = good.good_type.toString();
      that.form.topFullStatus = good.top_full_status.toString();
      that.form.noAdjustableGoods = good.no_adjustable_goods ? good.no_adjustable_goods.toString() : "2";
      that.form.can_out_type = good.can_out_type ? good.can_out_type.toString() : "2";
      
      that.form.type_id = good.type_id;
      this.form.score_price = good.score_price;
      this.form.order_index = good.order_index;
      this.form.thirdId = good.third_id;
      if (good.good_type == 1)
      {
        var subId = JSON.parse(good.sub_id);
        this.form.subId = subId[0].goodId;
        this.form.subIdNum = subId[0].num;
        this.form.domains = JSON.parse(good.sub_id);
      }
      that.form.good_name = good.good_name;
      that.form.ceo_buy_num = good.ceo_buy_num;
      that.form.new_ceo_buy_num = good.new_ceo_buy_num;
      that.form.new_area_buy_num = good.new_area_buy_num;
      that.form.exec_buy_num = good.exec_buy_num;
      
      that.form.xing_role_num = good.xing_role_num;
      
      that.form.new_province_buy_num = good.new_province_buy_num;
      that.form.city_buy_num = good.city_buy_num;
      that.form.province_buy_num = good.province_buy_num;
      that.form.shop_province_buy_num = good.shop_province_buy_num;


      that.form.vip_red_num = good.vip_red_num;
      that.form.high_red_num = good.high_red_num;
      that.form.top_red_num = good.top_red_num;
      that.form.red_city_num = good.red_city_num;
      that.form.red_province_num = good.red_province_num;
      that.form.red_ceo_num = good.red_ceo_num;
      that.form.vip_buy_num = good.vip_buy_num;
      that.form.video_path = good.video_path;
      
      that.form.high_buy_num = good.high_buy_num;
      that.form.nice_high_num = good.nice_high_num;
      that.form.index_status = good.index_status.toString();
      that.form.list_pic = good.list_pic;
      that.form.main_pic = good.main_pic;
      that.form.good_price = good.good_price;
      that.form.goodWeight = good.good_weight;
      that.form.goodSize = good.good_size;
      that.form.nice_district_price = good.nice_district_price;

      that.form.district_price = good.district_price;
      this.form.vip_price = good.vip_price;
      that.form.city_price = good.city_price;
      that.form.special_city_price = good.special_city_price;
      that.form.special_province_price = good.special_province_price;
      that.form.give_pic = good.give_pic;
      that.form.special_type = good.special_type.toString();
      that.form.unit_price = good.unit_price;
      that.form.province_price = good.province_price;
      that.form.ceo_price = good.ceo_price;
      that.form.top_price = good.top_price;
      that.form.special_price = good.special_price;


      that.form.new_ceo_money = good.new_ceo_money;
      that.form.new_province_money = good.new_province_money;
      that.form.new_area_money = good.new_area_money;
      that.form.exec_price = good.exec_price;
      that.form.xing_role_price = good.xing_role_price;
      
      that.form.new_pro_pro_money = good.new_pro_pro_money;
      that.form.new_ceo_one_money = good.new_ceo_one_money;
      that.form.new_ceo_two_money = good.new_ceo_two_money;


      that.form.unit_city_price = good.unit_city_price;
      that.form.unit_province_price = good.unit_province_price;
      that.form.send_score = good.send_score;
      that.form.unit_second_price = good.unit_second_price;
      that.form.unit_three_price = good.unit_three_price;
      that.form.unit_ceo_price = good.unit_ceo_price;
      that.form.content = good.content;
      // that.form.good_num = good.good_num;
      var url1 = JSON.parse(good.main_pic);
      for (var i = 0; i < url1.length; i++) {
        that.fileList4.push({
          name: url1[i].name,
          url: url1[i].url,
          uid: url1[i].uid,
          height: url1[i].height,
          width: url1[i].width
        });
        that.form.fileList2.push({
          name: url1[i].name,
          url: url1[i].url,
          uid: url1[i].uid,
          height: url1[i].height,
          width: url1[i].width
        });
      }
      that.fileList2 = that.form.fileList2;
      that.form.detail_pic = good.detail_pic;
      var url2 = JSON.parse(good.detail_pic);
      for (var i = 0; i < url2.length; i++) {
        that.form.fileList3.push({
          name: url2[i].path,
          url: url2[i].url,
          uid: url2[i].uid,
          height: url2[i].height,
          width: url2[i].width
        });
        that.fileList5.push({
          name: url2[i].path,
          url: url2[i].url,
          uid: url2[i].uid,
          height: url2[i].height,
          width: url2[i].width
        });
      }
      that.fileList3 = that.form.fileList3;
      //name,url,uid
      that.form.status = good.status.toString();
      // that.form.choose_type = [good.first_type_id, good.second_type_id];
    } else {
      that.form.status = "1";
      that.wordName = "立即创建";
    }
    // var para = {
    //   token: localStorage.getItem("api_token")
    // };
    // API.get_all_types(para)
    //   .then(
    //     function(result) {
    //       that.addLoading = false;
    //       if (result.key == 1000) {
    //         that.options = result.result.list;
    //         // resetForm();
    //       } else {
    //         that.$message.error({
    //           showClose: true,
    //           message: result.message || "登录失败",
    //           duration: 2000
    //         });
    //       }
    //     },
    //     function(err) {
    //       that.loading = false;
    //       console.error(err);
    //       that.$message.error({
    //         showClose: true,
    //         message: err.toString(),
    //         duration: 2000
    //       });
    //     }
    //   )
    //   .catch(function(error) {
    //     that.loading = false;
    //     console.error(error);
    //     that.$message.error({
    //       showClose: true,
    //       message: "请求出现异常",
    //       duration: 2000
    //     });
    //   });
  },
  computed: {},
  methods: {
    removeDomain(item) {
      var index = this.form.domains.indexOf(item)
      if (index !== -1) {
        this.form.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.form.domains.push({
        value: '',
        key: Date.now()
      });
    },
    changeGoodType(e)
    {

      this.typeOptions1 = [];
      this.form.type_id = null;
      for (var i=0; i<this.typeOptions.length;i++)
      {
        if (this.typeOptions[i].noVip == this.form.no_vip)
        {
          this.typeOptions1.push(this.typeOptions[i]);
        }
      }
    },
    backList() {
      this.$router.push({
        path: "/goodList"
      });
    },
    handleChange() {},
    handleRemove(file, fileList) {
      // for (var i = 0; i < this.fileList2.length; i++) {
      //   if (this.fileList2[i].name == file.name) {
      //     this.fileList2.splice(i, 1);
      //     return;
      //   }
      // }

      var list = [];
      for (var i = 0; i < this.fileList4.length; i++) {
        if (this.fileList4[i].uid && this.fileList4[i].uid != null) {
          if (this.fileList4[i].uid != file.uid) {
            list.push(this.fileList4[i]);
          }
        } else {
          if (this.fileList4[i].name != file.name) {
            list.push(this.fileList4[i]);
          }
        }
      }
      this.fileList4 = list;
      if (this.fileList4.length == 0) {
        this.form.main_pic = null;
      } else {
        this.form.main_pic = JSON.stringify(this.fileList4);
      }
    },
    handleRemove1(file, fileList) {
      var list = [];
      for (var i = 0; i < this.fileList5.length; i++) {
        if (this.fileList5[i].uid && this.fileList5[i].uid != null) {
          if (this.fileList5[i].uid != file.uid) {
            list.push(this.fileList5[i]);
          }
        } else {
          if (this.fileList5[i].name != file.name) {
            list.push(this.fileList5[i]);
          }
        }
      }
      this.fileList5 = list;
      if (this.fileList5.length == 0) {
        this.form.detail_pic = null;
      } else {
        this.form.detail_pic = JSON.stringify(this.fileList5);
      }
    },
    handlePreview(file) {},
    handleAvatarSuccess1: function(e, file) {
      if (e.key == 1000) {
        this.fileList4.push({
          name: file.name,
          uid: file.uid,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });
        this.form.main_pic = this.fileList4;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("main_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess2: function(e, file) {
      if (e.key == 1000) {
        this.fileList5.push({
          uid: file.uid,
          name: file.name,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });

        this.form.detail_pic = this.fileList5;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("detail_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.list_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccessGive: function(e) {
      if (e.key == 1000) {
        this.form.give_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    beforeAvatarUpload: function(e) {},
    onSubmit() {
      let that = this;
      console.log(this.form.domains)
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          if (dateFunc.isNumber(para.normal_price)) {
          }
          if (para.good_type == 1)
          {
            if (this.form.domains == null || this.form.domains.length == 0)
            {
              that.$message.error({
                showClose: true,
                message: "请选择关联商品和填写数量",
                duration: 2000
              });
              return;
            } else {
              para.sub_id = JSON.stringify(this.form.domains);
              delete para.subId;
              delete para.subIdNum;
              delete para.domains;
            }
          } else {
            para.sub_id = null;
          }
          if (para.no_vip == 2)
          {
            para.index_status = 2;
            para.send_score = 0;
            if (para.score_price == null)
            {
              para.score_price = 0;
            }
          }
          if (para.no_vip == 1 && (para.index_status == null || para.district_price == null || para.special_price == null || para.city_price == null || para.special_city_price == null || para.special_province_price == null || para.province_price == null || para.ceo_price == null || para.top_price == null  || para.vip_price == null || para.unit_three_price == null || para.unit_second_price == null || para.unit_ceo_price == null || para.unit_province_price == null || para.unit_city_price == null || para.unit_price == null || para.new_ceo_money == null || para.new_province_money == null || para.new_area_money == null  || para.exec_price == null  || para.xing_role_price == null || para.new_pro_pro_money == null || para.new_ceo_one_money == null || para.new_ceo_two_money == null)) {
            that.$message.error({
              showClose: true,
              message: "请上传检查是否有内容没有填写全",
              duration: 2000
            });
            return;
          }
          para.token = localStorage.getItem("api_token");
          if (that.fileList4.length == 0) {
            that.$message.error({
              showClose: true,
              message: "请上传轮播图片",
              duration: 2000
            });
            return;
          } else {
            para.main_pic = JSON.stringify(that.fileList4);
          }
          if (that.fileList5.length == 0) {
            that.$message.error({
              showClose: true,
              message: "请上传详情图片",
              duration: 2000
            });
            return;
          } else {
            para.detail_pic = JSON.stringify(that.fileList5);
          }

          that.addLoading = true;
          API.up_add_good(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }

                  // resetForm();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/good/add_good.vue